import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useIsCircleV4FeatureEnabled } from "@circle-react/hooks/useIsCircleV4FeatureEnabled";
import { Button } from "@circleco/compass/components/Button";
import { useCallback, useEffect, useState } from "react";

import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/SettingsApp/CompassCompat/Typography";

import { Icon } from "../Icon";
export interface PdfPreviewProps {
  className?: string;
  src: string;
}

export const PdfPreview = ({ src, className }: PdfPreviewProps) => {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_buttons_enabled");

  const getPdfBlobUrl = useCallback(async (pdfSrc: string) => {
    try {
      const response = await fetch(pdfSrc);
      if (!response.ok) throw new Error("Failed to fetch PDF");
      const blob = await response.blob();
      const pdfBlob = new Blob([blob], { type: "application/pdf" });
      setBlobUrl(URL.createObjectURL(pdfBlob));
    } catch (error) {
      console.error("Failed to fetch PDF", error);
    }
  }, []);

  useEffect(() => {
    if (src) {
      void getPdfBlobUrl(src);
    }
  }, [src, getPdfBlobUrl]);

  useEffect(
    () => () => {
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
      }
    },
    [blobUrl],
  );

  if (!blobUrl) {
    return (
      <div
        className={classNames("flex items-center justify-center", className)}
      >
        <Icon type="loader" />
      </div>
    );
  }

  return (
    <object data={blobUrl} type="application/pdf" className={className}>
      <div className="flex size-full flex-col items-center justify-center gap-3">
        <Typography.LabelSm>
          {t("tiptap.cannot_preview_pdf")}
        </Typography.LabelSm>
        {isCircleV4 ? (
          <Button
            renderLink={<a href={src} download aria-label={t("download")} />}
          >
            {t("download")}
          </Button>
        ) : (
          <a
            href={src}
            download
            className="text-inverse hover:text-inverse flex items-center gap-2 bg-brand hover:bg-brand-dark rounded-md px-4 py-2"
          >
            {t("download")}
          </a>
        )}
      </div>
    </object>
  );
};
